import { FC, useState, useEffect, useCallback } from 'react'
import { Button } from 'rsuite'
import throttle from 'lodash/throttle'
import { Crisp } from 'crisp-sdk-web'

import { animateScroll } from '../utils/scroll'
import ArrowUpIcon from './Icons/ArrowUpIcon'

import styles from '../styles/ScrollToTopButton.module.less'

interface ScrollToTopButtonProps {
  isChatOpened: boolean
}

// Constants for scroll behavior
const SCROLL_THRESHOLD = 600
const SCROLL_ANIMATION_DURATION = 600
const THROTTLE_DELAY = 200

const ScrollToTopButton: FC<ScrollToTopButtonProps> = ({ isChatOpened }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isChatVisible, setIsChatVisible] = useState(false)

  const toggleVisibility = useCallback(
    throttle(() => {
      if (window.scrollY > SCROLL_THRESHOLD) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }, THROTTLE_DELAY),
    [],
  )

  const scrollToTop = () => {
    const currentScrollPosition = window.scrollY
    animateScroll(currentScrollPosition, 0, SCROLL_ANIMATION_DURATION)
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  useEffect(() => {
    setIsChatVisible(Crisp.chat.isVisible())
  }, [isChatOpened])

  return (
    <div className={`${styles['scroll-to-top']} ${isVisible ? styles.visible : styles.hidden} ${isChatVisible ? styles['is-chat-visible'] : ''}`}>
      <Button
        appearance="primary"
        size="lg"
        onClick={scrollToTop}
        className={styles['scroll-button']}
        aria-label="Scroll to top"
      >
        <ArrowUpIcon />
      </Button>
    </div>
  )
}

export default ScrollToTopButton
